export const CUSTOM_PAGE_SETTINGS_FIELD = {
  theme: 1,
  schema: 'light',
  matchTheme: 'inherit',
  headerButton: {
    textColor: '#000000',
    bgColor: '#000000',
  },
  main: {
    mainColor: '#000000',
    fill: 'solid',
    bgColor: '#000000',
    overlayColor: '#000000',
    textColor: '#000000',
    iconColor: '#000000',
  },
  filter: {
    activeColor: '#000000',
    contentColor: '#000000',
  },
}

export const FILTER_OPTIONS = [
  {
    label: 'По виду спорта',
    value: 'sport',
  },
  {
    label: 'По времени',
    value: 'time',
  },
  {
    label: 'Лайв',
    value: 'live',
  },
  {
    label: 'Незавершенные',
    value: 'unfinished',
  },
  {
    label: 'С видео',
    value: 'video',
  },
]
